import apiClient from '../utils/apiClient';

class DishCategoryService {
    async getCategories(includeDishCounts = true) {
        const query = includeDishCounts ? '?includeDishCounts=true' : '';
        const response = await apiClient.get(`/dish-categories${query}`);
        return response;
    }

    async createCategory(categoryData) {
        const response = await apiClient.post('/dish-categories', categoryData);
        return response;
    }

    async updateCategory(categoryId, categoryData) {
        const response = await apiClient.patch(`/dish-categories/${categoryId}`, categoryData);
        return response;
    }

    async deleteCategory(categoryId) {
        const response = await apiClient.delete(`/dish-categories/${categoryId}`);
        return response;
    }

    async getPublicCategories(restaurantId) {
        const response = await apiClient.get(`/public/restaurants/${restaurantId}/dish-categories`);
        return response;
    }
}

const dishCategoryService = new DishCategoryService();

export default dishCategoryService;
